import Color from 'color';

export function getColorRGBA(color) {
    try {
        return Color(color).rgb().object();
    } catch (error) {
        console.log(error);
        return {};
    }
}

export function convertRGBtoRGBA(color) {
    const { r, g, b, alpha = 1 } = getColorRGBA(color);
    if (typeof r !== 'undefined') {
        return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    }
    return color;
}

export function converRGBAalpha(color, transparent) {
    const { r, g, b, alpha = 1 } = getColorRGBA(color);
    if (typeof r !== 'undefined') {
        return `rgba(${r}, ${g}, ${b}, ${alpha * transparent})`;
    }
    return color;
}

export function convertRGBAtoHEX(color) {
    try {
        return Color(color).hex();
    } catch (error) {
        return color;
    }
}

export function validRGBAColor(value) {
    return /(rgb)a\((\d{1,3}%?,\s?){3}(1|0?\.\d+)\)/.test(value);
}

export function getForegroundColor(color) {
    const { r = 0, g = 0, b = 0 } = getColorRGBA(color);
    const sum = Math.round((parseInt(r) * 299 + parseInt(g) * 587 + parseInt(b) * 114) / 1000);
    return sum > 128 ? 'black' : 'white';
}
